@use "sass:math";

$node-size: 36px;
$completed-node-size: 28px;
$bar-height: 12px;
$progress-background: var(--gray-02);
$progress-foreground: var(--blue-01);

@mixin bar {
  position: absolute;
  width: 100%;
  height: $bar-height;
  border-radius: math.div($bar-height, 2);
}

.wrapper {
  position: relative;
  height: 36px;
  width: 100%;
  display: flex;
  align-items: center;
}

.emptyBar {
  @include bar;
  background-color: $progress-background;
}

.completedBar {
  @include bar;
  background-color: $progress-foreground;
  max-width: calc(100% - #{math.div($node-size, 2)}); // Do not stretch the bar past the last completed node
}

.nodes {
  display: flex;
  position: absolute;
  width: 100%;
  justify-content: space-between;
}

.node {
  width: $node-size;
  height: $node-size;
  border-radius: 50%;

  &:first-child {
    visibility: hidden;
  }
}

.emptyNode {
  background-color: $progress-background;
}

.lastCompletedNode {
  $border-thickness: 2px;
  border: $border-thickness solid var(--blue-01-at-30);
  position: relative;
}

.completedNode {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: $completed-node-size;
  height: $completed-node-size;
  transform: translate(
    math.div($node-size - $completed-node-size, 2),
    math.div($node-size - $completed-node-size, 2)
  );
  background-color: $progress-foreground;
  border-radius: 50%;
}

.checkmark {
  width: 20px;
  height: 20px;
}
